// frontend/src/i18n/i18n.jsx
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import { resources } from './languages';

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: 'en',
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false,
    },
  });

// `common.weekdays.*` (and other picker vocabularies) are stored Title-Cased,
// because that is how they read as standalone labels. Interpolated mid-sentence
// that is wrong in every language whose weekdays are lowercase: Spanish "todos
// los Lunes", Dutch "elke Maandag", Polish "w kazdy Poniedzialek".
//
// Capitalisation is a property of the LANGUAGE, not of the value, so it belongs
// in the per-language string: English keeps `{{day}}`, the others ask for
// `{{day, lowercase}}`. i18next ships no such formatter (it passes the value
// through untouched), so it is registered here.
//
// `toLocaleLowerCase(lng)` rather than `toLowerCase()`: lowercasing is
// locale-sensitive (Turkish dotted/dotless I is the classic case), and the
// language the string is being rendered in is exactly the right locale for it.
i18n.services.formatter.add(
  'lowercase', (value, lng) => String(value).toLocaleLowerCase(lng),
);

export default i18n;